import {
  CLEAR_QUIZZES,
  CLEAR_QUIZ_OF_TODAY
} from '@/store/mutation-types'
import { firebaseAction } from 'vuexfire'
import l from '@/vendor/logger'
import { db } from '@/store'
import * as _ from 'ramda'
import { DB_TIMESTAMP } from '@/vendor/firebase'

const state = {
  currentAnswerForUid: {},
  quizOfToday: {},
  quizHistory: [],
  rightAnswer: {},
  numberOfRight: {},
  numberOfSelect: {},
  winners: [],
  quizIndex: 0,
  publishedQuizIndex: 0,
  totalParticipantsAtResult: 0
}

const getters = {
  totalNumberOfQuizzes (state) {
    if (state.quizOfToday.quizs) {
      let quizCount = 0
      state.quizOfToday.quizs.forEach(quiz => {
        if (quiz.type === 'quiz') {
          ++quizCount
        }
      })
      return quizCount
    } else {
      return ''
    }
  },
  totalNumberOfRight (state) {
    return state.numberOfRight
      ? Object
        .values(state.numberOfRight)
        .reduce((acc, cur) => acc + cur, 0)
      : ''
  },
  latestQuizId (state) {
    return state.quizOfToday.quizs
      ? Object.keys(_.last(state.quizOfToday.quizs))[0]
      : null
  },
  currentQuiz (state) {
    return state.quizHistory
      ? _.last(state.quizHistory)
      : new Error('quizzes/currentQuiz/not_exist')
  },
  quizIndex (state) {
    return state.quizIndex
      ? state.quizIndex['.value']
      : 0
  },
  publishedQuizIndex (state) {
    return state.publishedQuizIndex
      ? state.publishedQuizIndex['.value']
      : 0
  },
  latestNumberOfRight (state, getters) {
    return state.numberOfRight['.value'] && (getters.quizIndex > 0)
      ? state.numberOfRight['.value'][getters.quizIndex - 1]
      : 0
  },
  latestTotalParticipants (state, getters) {
    return state.totalParticipantsAtResult['.value'] && (getters.quizIndex > 0)
      ? state.totalParticipantsAtResult['.value'][getters.quizIndex - 1]
      : 0
  },
  latestNumberOfSelectCount (state, getters) {
    const nOs = state.numberOfSelect['.value'] && (getters.quizIndex > 0)
      ? state.numberOfSelect['.value'][getters.quizIndex - 1]
      : { s0: 0, s1: 0, s2: 0 }
    const count = nOs.s0 + nOs.s1 + nOs.s2
    return count
  },
  queryNumberOfRight (state) {
    return key => {
      return state.numberOfRight
        ? state.numberOfRight[key]
        : ''
    }
  },
  queryNumberOfSelect (state) {
    return key => {
      return state.numberOfSelect
        ? state.numberOfSelect[key]
        : ''
    }
  },
  quizHistory (state) {
    return state.quizHistory
      ? state.quizHistory
      : []
  },
  isBeforeSelectQuizzes (state) {
    return !state.quizOfToday.quizs
  },
  isBefore1stQuiz (state, getters) {
    return !getters.isBeforeSelectQuizzes && !state.quizHistory.length > 0
  },
  isBefore1stQuizSendAnswer (state, getters) {
    if (state.rightAnswer['.value'] === null) return true
    return !getters.isBefore1stQuiz && state.rightAnswer.index === 0
  },
  winners (state) {
    if (state.winners) {
      return state.winners
    }
  },
  currentAnswerForUid (state) {
    return (sel) => {
      const quizindex = state.quizHistory.length - 1
      const curAnswerForUid = state.currentAnswerForUid['.value']
      if (quizindex >= 0 && curAnswerForUid && curAnswerForUid[quizindex] && curAnswerForUid[quizindex][sel]) {
        return Object.keys(curAnswerForUid[quizindex][sel]).length
      } else {
        return 0
      }
    }
  }
}

const mutations = {
  [CLEAR_QUIZZES] (state) {
    state.quizOfToday = {}
    state.quizHistory = []
    state.rightAnswer = {}
    state.result = null
    state.quizIndex = 0
    state.publishedQuizIndex = 0
    state.winners = []
    state.currentAnswerForUid = {}
  },
  [CLEAR_QUIZ_OF_TODAY] (state) {
    state.quizOfToday = {}
  }
}

const actions = {
  bindQuizOfToday: firebaseAction(({ bindFirebaseRef }) => {
    bindFirebaseRef('quizOfToday', db.ref(`quizOfToday`))
  }),

  unbindQuizOfToday: firebaseAction(({ unbindFirebaseRef, rootState, commit }) => {
    unbindFirebaseRef('quizOfToday', db.ref(`quizOfToday`))
    db.ref(`quizOfToday`).off()
    commit(CLEAR_QUIZ_OF_TODAY)
  }),

  bindCurrentAnswerForUid: firebaseAction(({ bindFirebaseRef, rootState }) => {
    bindFirebaseRef('currentAnswerForUid', db.ref(`currentAnswerForUid/${rootState.rid}`))
  }),

  unbindCurrentAnswerForUid: firebaseAction(({ unbindFirebaseRef, rootState }) => {
    unbindFirebaseRef('currentAnswerForUid', db.ref(`currentAnswerForUid/${rootState.rid}`))
    db.ref(`currentAnswerForUid/${rootState.rid}`).off()
  }),

  bindQuizzes: firebaseAction(({ bindFirebaseRef, rootState }) => {
    bindFirebaseRef('quizOfToday', db.ref(`quizOfToday`))
    bindFirebaseRef('quizHistory', db.ref(`quizHistory/${rootState.rid}`))
    bindFirebaseRef('rightAnswer', db.ref(`result/${rootState.rid}/rightAnswer`))
    bindFirebaseRef('numberOfRight', db.ref(`result/${rootState.rid}/numberOfRight`))
    bindFirebaseRef('numberOfSelect', db.ref(`result/${rootState.rid}/numberOfSelect`))
    bindFirebaseRef('quizIndex', db.ref(`room/${rootState.rid}/quizIndex`))
    bindFirebaseRef('publishedQuizIndex', db.ref(`room/${rootState.rid}/publishedQuizIndex`))
    bindFirebaseRef('totalParticipantsAtResult', db.ref(`result/${rootState.rid}/totalParticipants`))
    bindFirebaseRef('winners', db.ref(`result/${rootState.rid}/winners`))
  }),

  unbindQuizzes: firebaseAction(({ unbindFirebaseRef, rootState, commit }) => {
    unbindFirebaseRef('quizOfToday', db.ref(`quizOfToday`))
    unbindFirebaseRef('quizHistory', db.ref(`quizHistory/${rootState.rid}`))
    unbindFirebaseRef('rightAnswer', db.ref(`result/${rootState.rid}/rightAnswer`))
    unbindFirebaseRef('numberOfRight', db.ref(`result/${rootState.rid}/numberOfRight`))
    unbindFirebaseRef('numberOfSelect', db.ref(`result/${rootState.rid}/numberOfSelect`))
    unbindFirebaseRef('quizIndex', db.ref(`room/${rootState.rid}/quizIndex`))
    unbindFirebaseRef('publishedQuizIndex', db.ref(`room/${rootState.rid}/publishedQuizIndex`))
    unbindFirebaseRef('totalParticipantsAtResult', db.ref(`result/${rootState.rid}/totalParticipants`))
    unbindFirebaseRef('winners', db.ref(`result/${rootState.rid}/winners`))
    db.ref(`quizOfToday`).off()
    db.ref(`quizHistory/${rootState.rid}`).off()
    db.ref(`result/${rootState.rid}/rightAnswer`).off()
    db.ref(`result/${rootState.rid}/numberOfRight`).off()
    db.ref(`result/${rootState.rid}/numberOfSelect`).off()
    db.ref(`room/${rootState.rid}/quizIndex`).off()
    db.ref(`result/${rootState.rid}/winners`).off()
    commit(CLEAR_QUIZZES)
  }),

  async sendQuiz ({ state, getters, rootState }, quiz) {
    if (!quiz) { throw new Error('quizzes/sendQuiz/no_quiz') }
    if (!rootState.rid) { throw new Error('quizzes/sendQuiz/no_rid') }
    try {
      if (quiz.type === 'quiz') {
        const quizWithoutAnswer = {
          question: quiz.question,
          selection: quiz.selection,
          refIndex: quiz.refIndex,
          sentedTime: DB_TIMESTAMP
        }
        l.d('quizzes/sendQuiz', `quiz/${rootState.rid}/${getters.quizIndex}`, quizWithoutAnswer)
        await db.ref(`room/${rootState.rid}/status`).set('QUIZ')
        await db.ref(`room/${rootState.rid}/publishedQuizIndex`).set(getters.quizIndex)
        await db.ref(`room/${rootState.rid}/quizStatus`).set('PUBLISHED')
        await db.ref(`quiz/${rootState.rid}/${getters.quizIndex}`).set(quizWithoutAnswer)
        // await db.ref(`quizHistory/${rootState.rid}/${getters.quizIndex}`).set(quiz)
      } else if (quiz.type === 'custom') {
        await db.ref(`customEvent/${rootState.rid}`).push({ ...quiz, status: 'open' })
      }
    } catch (err) {
      l.e('quizzes/sendQuiz', err)
    }
  },

  async modifyQuiz ({ state, getters, rootState }, quiz) {
    l.d('quizzes/modifyQuiz', quiz)
    if (!quiz) { throw new Error('quizzes/modifyQuiz/no_quiz') }
    if (!rootState.rid) { throw new Error('quizzes/modifyQuiz/no_rid') }
    try {
      if (quiz.type === 'quiz') {
        const quizWithoutAnswer = {
          question: quiz.question,
          selection: quiz.selection,
          answer: quiz.answer
        }
        await db.ref(`quizOfToday/quizs/${quiz.refIndex}`).update(quizWithoutAnswer)
        // await db.ref(`quizHistory/${rootState.rid}/${getters.quizIndex}`).set(quiz)
      } else if (quiz.type === 'custom') {
        await db.ref(`customEvent/${rootState.rid}`).push({ ...quiz, status: 'open' })
      }
    } catch (err) {
      l.e('quizzes/sendQuiz', err)
    }
  },

  async fetchQuizzes ({ state, getters, rootState }, lo) {
    l.d('quizzes/fetchQuizzes', lo)
    if (!rootState.rid) { throw new Error('quizzes/sendQuiz/no_rid') }
    try {
      // actionTrigger/fetchQuizofToday/{roomID}
      await db.ref(`actionTrigger/fetchQuizofToday/${rootState.rid}`).set({ lo: lo, timeStamp: DB_TIMESTAMP })
    } catch (err) {
      l.e('quizzes/sendQuiz', err)
    }
  },

  async sendRightAnswer ({ state, rootState, getters }, isAll = false) {
    if (!getters.currentQuiz.question) { throw new Error('quizzes/sendRightAnswer/no_question') }
    if (!rootState.rid) { throw new Error('quizzes/sendRightAnswer/no_rid') }
    if (getters.quizIndex < 0) { throw new Error('quizzes/sendRightAnswer/quizIndex_smaller_then_zero') }
    try {
      const ra = {
        question: getters.currentQuiz.question,
        answer: isAll ? 60 : getters.currentQuiz.answer,
        index: getters.quizIndex,
        status: 'sent',
        refIndex: getters.currentQuiz.refIndex
      }
      l.d(`quizzes/sendRightAnswer`, ra)
      await db.ref(`result/${rootState.rid}/rightAnswer`).set(ra)
      await db.ref(`room/${rootState.rid}/quizStatus`).set('READY')
    } catch (err) {
      l.e('quizzes/sendRightAnswer', err)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
